import api, { apiWrapper } from '../api/axios';

export const getClients = async (
  {
    status = 'all', search = null,
    branch = null, customer = null,
    page = 1, pageSize = 20, paginate = true
  }
) => {
  let params = {
    status,
    page,
    page_size: pageSize,
    paginate
  };
  if (search)    params.search   = search;
  if (branch)    params.branch   = branch;
  if (customer)  params.customer = customer;
  return apiWrapper(() => api.get(`/client/`, { params }));
};

export const createClient = async (data) => {
  return apiWrapper(() => api.post("/client/", data));
};

export const updateClient = async (id, data) => {
  return apiWrapper(() => api.put(`/client/${id}/`, data));
};

export const updateClientPartial = async (id, data) => {
  return apiWrapper(() => api.patch(`/client/${id}/`, data));
};

export const toggleClientStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/client/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};
